var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"list"},[_c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"page-header__title"},[_vm._v("Tabela zgłoszeń")]),_c('ReportStats',{attrs:{"reports":_vm.reports}})],1),_c('ReportList',{attrs:{"reports":_vm.reports}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }